import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import {UserOutlined} from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 *
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/cms',
    name: 'cms',
    redirect: '/cms/index',
    component: Layout,
    meta: {
      title: '内容管理',
      icon: renderIcon(UserOutlined),
      sort: 3,
      roles: ['cms manager'],
    },
    children: [
      {
        path: 'article',
        name: 'cms-article-index',
        meta: {
          title: '文章列表',
        },
        component: () => import('@/views/cms/article/index/index.vue'),
      },
      {
        path: 'article/create',
        name: 'cms-article-create',
        meta: {
          title: '新增文章',
          hidden: true,
        },
        component: () => import('@/views/cms/article/createOrEdit/index.vue'),
      },
      {
        path: 'article/edit/:id',
        name: 'cms-article-edit',
        meta: {
          title: '修改文章',
          hidden: true,
        },
        component: () => import('@/views/cms/article/createOrEdit/index.vue'),
      },
      {
        path: 'category',
        name: 'cms-category-index',
        meta: {
          title: '分类列表',
        },
        component: () => import('@/views/cms/category/index/index.vue'),
      },
      {
        path: 'tag',
        name: 'cms-tag-index',
        meta: {
          title: '标签列表',
        },
        component: () => import('@/views/cms/tag/index/index.vue'),
      },
      {
        path: 'student',
        name: 'cms-student-index',
        meta: {
          title: '学员成绩',
        },
        component: () => import('@/views/cms/student/index/index.vue'),
      },
      {
        path: 'teacher',
        name: 'cms-teacher-index',
        meta: {
          title: '名师经验',
        },
        component: () => import('@/views/cms/teacher/index/index.vue'),
      },
      {
        path: 'course',
        name: 'cms-course-index',
        meta: {
          title: '课程信息',
        },
        component: () => import('@/views/cms/course/index/index.vue'),
      },
      {
        path: 'team',
        name: 'cms-team-index',
        meta: {
          title: '教研团队',
        },
        component: () => import('@/views/cms/team/index/index.vue'),
      },
    ],
  },
];

export default routes;
